import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

import type { TipoPrazo } from '../types/tipoPrazoTypes';

export const selectTiposPrazo = (state: RootState) => state.tiposPrazo.tiposPrazo;
export const selectTiposPrazoLoading = (state: RootState) => state.tiposPrazo.isLoading;
export const selectTiposPrazoSaving = (state: RootState) => state.tiposPrazo.isSaving;
export const selectTiposPrazoError = (state: RootState) => state.tiposPrazo.error;

/** Tipos de prazo ativos — para uso nos seletores dos blocos de Controle de Tempo. */
export const selectTiposPrazoAtivos = createSelector(
  [selectTiposPrazo],
  (tiposPrazo): TipoPrazo[] => tiposPrazo.filter((tipo) => tipo.ativo),
);
